var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('hc-grid',{staticClass:"grid-2_xs-1"},[_c('hc-col',[_c('hc-input',{attrs:{"row":"","label":_vm.$localize('broker-merchant-name'),"id":_vm.generateId('merchant-name')},model:{value:(_vm.value.merchantName),callback:function ($$v) {_vm.$set(_vm.value, "merchantName", $$v)},expression:"value.merchantName"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }